import React, { useState } from 'react';
import { Button, Divider, ListItemText, ListSubheader, Menu, MenuItem } from '@mui/material';
import { Add, NotesOutlined } from '@mui/icons-material';
import type { AdmissionField, BuiltInFormField } from '../../../../types/admissions';

interface Props {
  /** Built-in fields not on the form yet. */
  builtIns: BuiltInFormField[];
  onQuestion: () => void;
  onBuiltIn: (field: AdmissionField) => void;
}

/** Add a question of the school's own, or put back one of EduBook's built-in fields. */
const AddQuestionMenu: React.FC<Props> = ({ builtIns, onQuestion, onBuiltIn }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const groups = builtIns.reduce<Array<{ title: string; items: BuiltInFormField[] }>>((acc, b) => {
    const g = acc.find(x => x.title === b.section.title);
    if (g) g.items.push(b); else acc.push({ title: b.section.title, items: [b] });
    return acc;
  }, []);
  const pick = (fn: () => void) => { setAnchor(null); fn(); };

  return (
    <>
      <Button variant="outlined" startIcon={<Add />} onClick={e => setAnchor(e.currentTarget)} sx={{ textTransform: 'none', fontWeight: 600, borderStyle: 'dashed' }}>
        Add question
      </Button>
      <Menu
        anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}
        PaperProps={{ sx: { width: 320, maxHeight: 440 } }}
      >
        <MenuItem onClick={() => pick(onQuestion)}>
          <NotesOutlined fontSize="small" sx={{ mr: 1.5, color: 'text.secondary' }} />
          <ListItemText primary="Your own question" secondary="Any wording, any type" />
        </MenuItem>
        {groups.length > 0 && <Divider />}
        {groups.flatMap(g => [
          <ListSubheader key={`h-${g.title}`} sx={{ lineHeight: '32px', fontSize: 12 }}>Built-in · {g.title}</ListSubheader>,
          ...g.items.map(b => (
            <MenuItem key={b.field.key} onClick={() => pick(() => onBuiltIn(b.field))} sx={{ pl: 3 }}>
              <ListItemText primary={b.field.label} />
            </MenuItem>
          )),
        ])}
      </Menu>
    </>
  );
};

export default AddQuestionMenu;
